import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilDispositivoService {
  
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  getDispositivoPerfil(params,id): Observable<any> {
    this.httpOptions.params = params;
      return this.http.get(`${this.apiUrl}api/perfil-maquina/verificar/dispositivo/portal/${id}`, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  getSoftwaresListagem(params, filtro): Observable<any> {
    this.httpOptions.params = params
      return this.http.post(`${this.apiUrl}api/perfil-maquina/softwares/listagem`, filtro, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  getDipositivoPerfilList(params, filters): Observable<any> {
    this.httpOptions.params = params;
      return this.http.post(`${this.apiUrl}api/perfil-maquina/listagem`, filters, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  getDipositivoPerfilById(id): Observable<any> {
    this.httpOptions.params = '';
      return this.http.get(`${this.apiUrl}api/perfil-maquina/${id}`, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  createDipositivoPerfil(payload): Observable<any> {
    this.httpOptions.params = '';
      return this.http.post(`${this.apiUrl}api/perfil-maquina`, payload, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  updateDipositivoPerfil(payload): Observable<any> {
    this.httpOptions.params = '';
      return this.http.put(`${this.apiUrl}api/perfil-maquina`, payload, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  updateCreatePerfilMaquinaSoftware(payload): Observable<any> {
    this.httpOptions.params = '';
      return this.http.post(`${this.apiUrl}api/perfil-maquina/softwares`, payload, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  deletePerfilMaquinaSoftware(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/perfil-maquina/softwares/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletePerfilMaquina(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/perfil-maquina/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  duplicatePerfilMaquina(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/perfil-maquina/duplicar/${id}`, '', this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  /* DROPDOWNS */
  getTipoSistemaOperacional(): Observable<any> {
    this.httpOptions.params = ''
      return this.http.get(`${this.apiUrl}api/perfil-maquina/tipo-sistema-operacional/dropdown`, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  getExpressoes(): Observable<any> {
    this.httpOptions.params = ''
      return this.http.get(`${this.apiUrl}api/perfil-maquina/expressao/dropdown`, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }
  getOSVersoes(id): Observable<any> {
    this.httpOptions.params = ''
      return this.http.get(`${this.apiUrl}api/perfil-maquina/sistema-operacional/dropdown/${id}`, this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
